/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Cmp_License_PrInputs */

const en_fc_cmp_license_pr = /** @type {(inputs: Fc_Cmp_License_PrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proprietary subscription`)
};

/**
* | output |
* | --- |
* | "Proprietary subscription" |
*
* @param {Fc_Cmp_License_PrInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_cmp_license_pr = /** @type {((inputs?: Fc_Cmp_License_PrInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Cmp_License_PrInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_cmp_license_pr(inputs)
});
export { fc_cmp_license_pr as "fc.cmp.license.pr" }